import { FabricRectangular } from "../../../../views/grid/components/FabricRectangular";
import { roundRect } from "../../../../utils/utils";
import { DATA_MODEL_PROPERTY_LABEL_STYLE } from "./config/property.config";
import { ClassText } from "./ClassText";
import { DiagramUtils } from "../../../../diagram/diagram-assets/DiagramUtils";

export class PropertyAddInstance extends FabricRectangular {
    layout = {
        width: null, height: null, x: null, y: null
    };

    state = { selected: false, drawed: false, readonly: false };

    ctx;

    data;

    uuid;

    labelStyle = DATA_MODEL_PROPERTY_LABEL_STYLE;

    labelInstance;

    addPropertyConfig = {
        rectangularHeight: 30,
        rectPadding: 10,
        radius: 20
    };

    constructor(layout, state, ctx, data) {
        super(layout);
        this.layout = layout;
        if (state) this.state = { ...this.state, ...state };
        this.ctx = ctx;
        this.data = data || {};
        if (this.data.uuid) {
            this.uuid = data.uuid;
            delete data.uuid;
        } else this.uuid = new DiagramUtils().generateUUID();
    }

    draw() {
        if (this.state.drawed) {
            this.clear();
            this.state.drawed = false;
        }
        if (this.state.readonly) {
            return;
        }
        this.state.drawed = true;
    }

    getLayout() {
        const x = this.layout.x + this.addPropertyConfig.rectPadding;
        const y = this.layout.y + this.addPropertyConfig.rectPadding;
        const height = this.layout.height - this.addPropertyConfig.rectPadding * 2;
        const width = this.layout.width - this.addPropertyConfig.rectPadding * 2;
        return {
            x, y, height, width
        };
    }

    drawLabel() {
        // let layout = { x: this.layout.x, y: this.layout.y, width: this.layout.width, height: this.layout.height };
        const layout = this.getLayout();
        const style = { ...DATA_MODEL_PROPERTY_LABEL_STYLE };
        style.textAlign = "center";
        style.fontWeight = 500;
        style.selectedText = style.deselectedText = "#256BDE";
        if (!this.labelInstance) {
            this.labelInstance = new ClassText(this.state, layout, style, this.ctx, this.data.label);
        } else {
            this.labelInstance.update(this.state, layout, null, this.data.label);
        }
        this.labelInstance.draw();
    }

    clear() {
        this.state.drawed = false;
        const layout = this.getLayout();
        this.ctx.clearRect(layout.x, layout.y, layout.width, layout.height);
    }

    update(layout, state, data) {
        if (layout) {
            this.layout = { ...this.layout, ...layout };
            this.setPoints(this.layout);
        }
        if (state) this.state = { ...this.state, ...state };
        if (data) this.data = { ...this.data, ...data };
    }
}
